import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

const PurchaseSection = (props) =>
{
  return (

    <section id="purchase-section" class="has-background-white-ter">
      <div class="columns">
        <div class="column is-half p-0 ">
          <StaticImage
            src="../images/Inkoop.jpg"
            imgStyle={{ height: "100%", }}
            style={{ height: "100%" }}
            quality={100}
            formats={["AUTO", "WEBP", "AVIF"]}
            alt="Brand logo"
          />
        </div>
        <div class="column is-half p-6">
          <section class="section is-medium">
            <div class="container">
              <div class="content" data-sal="slide-left"
                data-sal-delay="300"
                data-sal-easing="ease">
                <h1 class="title pb-5 mainfont" >{props.title}</h1>
                <div class="description mainfont is-size-5" >
                  <p>{props.description}</p>
                </div>
              </div>
            </div>
          </section>
        </div >
      </div >
    </section >
  )
}
export default PurchaseSection;